import { ContactTemplatePage } from '.';

export const WhatHappensNextContent = () => {
  return (
    <div className="text-bodyLg flex flex-col gap-4">
      <p>
        You do not have to contact us. The police will tell us if we need to
        remove the vehicle.
      </p>
      <p>
        You can contact the police directly for an update if you have a crime
        reference number.
      </p>
      <p>
        <span className="font-bold">Telephone:</span>
        {` `}101
      </p>
      <p>
        <span className="font-bold">Hearing or speech impairments:</span>
        {` `}If you have a hearing or speech impairment, use their textphone
        service 18001 101.
      </p>
    </div>
  );
};

export const WhatHappensNextPage = () => {
  return (
    <ContactTemplatePage
      title="What happens next?"
      content={<WhatHappensNextContent />}
    />
  );
};
